
const AromataseContent = () => {
    return (
        <>
            <h4>
                Aromatase inhibitors
            </h4>
            <p>
            Research shows that aromatase inhibitors reduce the risk of postmenopausal women with the most common form of breast cancer (oestrogen and/or progesterone receptor positive) dying of their disease by 40% after 5 years.
            </p>
        </>
    );
}

export default AromataseContent;